import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroTextColumn,
    DateColumn,
    NonZeroNumberColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Operator', 'operator'),
        new DateColumn('Despatch closed', 'despatchCloseDate')
          .withWidth(150),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId')
          .withWidth(255)),
        new NonZeroNumberColumn('Location code list', 'locationCodeList'),
        new TextColumn('Location', 'location'),
        new NonZeroTextColumn('No IATA', 'noIata'),
        new TextColumn('Type', 'type'),
      ],
    },
  ];
};
